import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import Constants from "../../../../common/Constants";
import MasterList from "../../../common/MasterList";
import ModalBody from "../../../common/ModalBody";
import ModalHeader from "../../../common/ModalHeader";
import UserDepartmentForm from "./UserDepartmentForm";

const UserDepartment = (props) => {

  const { t } = useTranslation();
  const [selectedItem, setSelectedItem] = useState([]);
  const [deptFormOpen, setDeptFormOpen] = useState(false);


  const handleDeptFormOpen = () => {
    setDeptFormOpen(true);
  };

  const handleDeptFormClose = () => {
    setDeptFormOpen(false);
  };

  const handleRowSelected = ({ selectedRows }) => {
    setSelectedItem(selectedRows);
  };

  const handleDelete = (data, singleDelete = false) => {
    let unique = [];
    let selected = selectedItem
    if (singleDelete) {
      selected = [data];
    }
    let departments = props.user.departments ? props.user.departments : []
    for (let i = 0; i < departments.length; i++) {
      let found = false;
      for (let j = 0; j < selected.length; j++) { // j < is missed;
        if (departments[i].deptCode === selected[j].deptCode) {
          found = true;
          break;
        }
      }
      if (found === false) {
        unique.push(departments[i]);
      }
    }
    const user = { ...props.user }
    user.departments = unique
    props.onAdd(user)
  };

  const columnsData = [
    {
      name: t("msg_common.actions"),
      cell: (row) => (
        <>
          <span>
            <i
              className="bi bi-trash3 iconTable"
              onClick={() => handleDelete(row, true)}
            ></i>
          </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Department Code",
      selector: (row) => row.deptCode,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.deptCode} </p>
        </div>
      ),
    },
    {
      name: "Department Name",
      selector: (row) => row.deptName,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.deptName} </p>
        </div>
      ),
    }
  ];

  const { onHide } = props;
  return (
    <>
      <Modal
        {...props}
        dialogClassName="modal-50w"
        onHide={onHide}
        animation={false}
      >
        <ModalHeader
          title={t("msg_master_list.msg_user.mapped_departments")}
        ></ModalHeader>
        <ModalBody>
          <MasterList
            columnsData={columnsData}
            handleOpen={handleDeptFormOpen}
            rowsData={props.user?.departments || []}
            paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
            pagination
            selectableRows
            handleDelete={handleDelete}
            cardHeader={true}
            handleRowSelected={handleRowSelected}
            
          />
        </ModalBody>
      </Modal>
      {deptFormOpen && (
        <UserDepartmentForm
          user={props.user}
          onSave={props.onAdd}
          show={deptFormOpen}
          onHide={handleDeptFormClose}
        ></UserDepartmentForm>
      )}
    </>
  );
};

export default UserDepartment;
